import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container-tiles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    class: "container-widget",
    widthType: _ctx.WidthType.third
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        title: _ctx.widget.libelle,
        iconUrl: _ctx.loadIcon,
        "mode-edition": true,
        onFiltre: _ctx.filtre,
        onDupliquer: _ctx.dupliquer,
        onSuppression: _ctx.suppression
      }, null, 8, ["title", "iconUrl", "onFiltre", "onDupliquer", "onSuppression"]),
      _createElementVNode("div", null, [
        (_ctx.widget.site == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Tile, {
          class: "tile",
          value: 1,
          color: "--edition-clair",
          titleNotBold: _ctx.$tc('estimateWidget.estimate'),
          titleInBold: _ctx.$t('estimateWidget.toValidate'),
          "is-loading": false
        }, null, 8, ["titleNotBold", "titleInBold"]),
        _createVNode(_component_Tile, {
          class: "tile",
          value: 2,
          color: "--edition-medium",
          titleNotBold: _ctx.$t('estimateWidget.estimate'),
          titleInBold: _ctx.$t('estimateWidget.awaitingRealization'),
          "is-loading": false
        }, null, 8, ["titleNotBold", "titleInBold"]),
        _createVNode(_component_Tile, {
          class: "tile",
          value: 3,
          color: "--edition-fonce",
          titleNotBold: _ctx.$t('estimateWidget.estimate'),
          titleInBold: _ctx.$tc('estimateWidget.inProgress', 3),
          "is-loading": false
        }, null, 8, ["titleNotBold", "titleInBold"])
      ])
    ]),
    _: 1
  }, 8, ["widthType"]))
}